module.exports = __webpack_public_path__ + "img/electric-mining-drill-W-patch.25e253fd.png";